import React from 'react';
import { CheckIcon } from 'lucide-react';
import { BOX_IMAGE } from '../data/product';
const FEATURES = ['Visual diagnostic workflows', 'Fault-finding sequences', 'Testing guides', 'Diagnostic decision trees', 'Scan-data references', 'Professional workshop tools'];
export function SystemOverview() {
  return <section className="bg-navy px-4 py-6 text-white sm:py-8" data-id="element-164" data-mp="1hovshvgcsvih">
      <div className="mx-auto max-w-5xl" data-id="element-165" data-mp="txgm9rlghu1y">
        <h2 className="text-center text-2xl sm:text-4xl" data-id="element-166" data-mp="tyi90tbu44zi">
          THE COMPLETE <span className="text-cyan" data-id="element-167" data-mp="px6eqai0mvkz">6-IN-1</span> DIAGNOSTIC
          SYSTEM
        </h2>

        <div className="mt-4 grid items-center gap-4 md:grid-cols-2" data-id="element-168" data-mp="13wfyfk5fk7tp">
          <a href="#offer" className="block" data-id="element-169" data-mp="yx2zi11abaar">
            <img src={BOX_IMAGE} alt="The complete 6-in-1 AUTOMOTIVE DIAGNOSTIC PRO™ system" className="mx-auto w-full max-w-sm" loading="lazy" data-id="element-170" data-mp="ywbf7md50yzs" />
          </a>

          <div data-id="element-171" data-mp="2aeci6lcl9yb0">
            <p className="font-display text-2xl uppercase text-cyan sm:text-3xl" data-id="element-172" data-mp="2aemcum8kwtn1">
              🔧 AUTOMOTIVE DIAGNOSTIC PRO™
            </p>
            <p className="mt-1 font-mono text-[11px] uppercase tracking-wider text-white/70 sm:text-xs" data-id="element-173" data-mp="284fmpb3gnyy0">
              Workflow • Engine • Electrical • OBD-II • Symptoms • Networks
            </p>
            <ul className="mt-3 grid gap-1.5 sm:grid-cols-2" data-id="element-174" data-mp="2i3wohhfldsop">
              {FEATURES.map(feature => <li key={feature} className="flex items-start gap-1.5 text-sm font-semibold leading-snug text-white/90" data-id="element-175" data-mp="1kgxtrc8gmutg">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cyan" aria-hidden="true" data-id="element-176" data-mp="1udiuvmhczls0" />
                  {feature}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}